import useCart from "hooks/useCart.js";
import { useQuery } from "react-query";
import { getCartEligibility, getFilterActivation } from "components/localOfferEligibility/LocalOfferEligibility";
import { pushLocalOfferFilter } from "lib/gtm";

export default function useDeliveryOptions(product_id, product_type) {
  const [cart] = useCart();

  const isClientEligibleToLocalOffer = getCartEligibility(cart);
  getFilterActivation() && pushLocalOfferFilter(cart.shipping.address.zipcode, !!isClientEligibleToLocalOffer);

  const { data: deliveryOptions } = useQuery([
    `shipping/delivery-options/${cart.shipping.address.zipcode}`,
    { local: isClientEligibleToLocalOffer, product_id: product_id, product_type: product_type },
  ]);
  return (
    deliveryOptions &&
    deliveryOptions.sort((a, b) => {
      if (a.price < b.price) return -1;
      return 1;
    })
  );
}
